import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetTkv2OrderDepreciationSettingsAPIError,
  GetTkv2OrderDepreciationSettingsAPIVariables,
  fetchGetTkv2OrderDepreciationSettingsAPI,
} from '../toolkitComponents.js';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.js';
import { Registry } from './registry.js';

type Response = z.infer<typeof schema>;
const { schema } = Registry.getTkv2OrderDepreciationSettingsAPI;

export function useGetTkv2OrderDepreciationSettingsAPI(
  variables: GetTkv2OrderDepreciationSettingsAPIVariables,
  opts?: UseQueryOptions<Response, GetTkv2OrderDepreciationSettingsAPIError>,
): UseQueryResult<Response> {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<Response, GetTkv2OrderDepreciationSettingsAPIError>(
    queryKeyFn({
      path: '/api/v2/orders/{orderID}/depreciationSettings',
      operationId: 'getTkv2OrderDepreciationSettingsAPI',
      variables,
    }),
    async () => {
      const res = await fetchGetTkv2OrderDepreciationSettingsAPI({
        ...fetcherOptions,
        ...variables,
      });
      return schema.parse(res);
    },
    opts,
  );
}
